import React, { FC, useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import theme from './theme.scss';
import Loader from 'components/Loader';

import { useMutation } from 'react-apollo';

import ORDER_FOOD from 'graphql/mutations/orderFoodOnBehalf.graphql';

type OrderFoodProps = {
  orderRequestObject,
  resetOrderForm
};

type OrderFoodResponse = {
  id?: string;
  totalPrice?: number;
  referenceId?: string;
  status?: number;
  createdAt?: string;
  additionalInfo?: string;
};

const OrderFood: FC<OrderFoodProps> = ({ orderRequestObject, resetOrderForm }) => {
  const [orderFoodOnBehalf, { data, loading, error }] = useMutation(ORDER_FOOD);

  const order: OrderFoodResponse = (data || { orderFoodOnBehalf: {} }).orderFoodOnBehalf;
  function initiateOrder() {
    orderFoodOnBehalf({
      variables: {
        vendorId: orderRequestObject.vendorId,
        organizationId: orderRequestObject.organizationId,
        dishes: orderRequestObject.dishes,
        phoneNumber: orderRequestObject.phoneNumber,
        name: orderRequestObject.name,
        email: orderRequestObject.email,
        paymentMode: 'PURSE',
      },
    });
  };

  if(order && order.id)
    resetOrderForm(true);

  useEffect(() => initiateOrder(), [])

  return (
    <div className={theme.menuTable}>
      {(!loading && !error && order) ? (
      <div>
        <h2>ORDER INFORMATION</h2>
        <Table unstackable compact className={theme.itemTable}>
          <Table.Header className={theme.itemHeader}>
            <Table.Row>
              <Table.HeaderCell width="5">REFERENCE ID</Table.HeaderCell>
              <Table.HeaderCell width="3" minWidth={992}>
                USER NAME
              </Table.HeaderCell>
              <Table.HeaderCell width="3" minWidth={992}>
                PRICE
              </Table.HeaderCell>
              <Table.HeaderCell width="8" textAlign="center">
                STATUS
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body className={theme.itemBody}>
            <Table.Row key={order.id} className={theme.itemRow}>
              <Table.Cell width="8" textAlign="center">
                {order.referenceId}
              </Table.Cell>
              <Table.Cell width="5">{order.additionalInfo ? JSON.parse(order.additionalInfo).name : ''}</Table.Cell>
              <Table.Cell width="3" minWidth={992}>
                ₹ {order.totalPrice}
              </Table.Cell>
              <Table.Cell width="8" textAlign="center">
                {order.status}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>) : (<div>
        <Loader />
        </div>) }
    </div>
  );
};

export default OrderFood;
